import { DotLegalLink, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { TableCell, TableRow } from "@mui/material";
import ReadOnlyTableDialog from "@common/components/readOnlyTableDialog/ReadOnlyTableDialog";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import { useTranslation } from "../../../localization/useTranslation";
import { useUrlProvider } from "../../../useUrlProvider";
import { PolicyViewItem } from "../ProcessingActivityOverview.types";

export interface IPolicyOverviewDialog {
    onDialogClose: () => void;
    policies: Array<PolicyViewItem>;
}

export default function PolicyOverviewDialog(props: IPolicyOverviewDialog) {
    const { translateString, translatePolicyTypes } = useTranslation();
    const { getPolicyUrl } = useUrlProvider();
    const { permissions } = useUserContext();

    const headers: Array<ITableHeader<PolicyViewItem>> = [
        { property: "name", text: translateString("policy"), align: "left", showOnMobile: true },
        { property: "type", text: translateString("type"), align: "left", showOnMobile: true },
    ];

    return (
        <ReadOnlyTableDialog
            header={translateString("policies")}
            emptyText={translateString("noPoliciesMatchesQuery")}
            headers={headers}
            data={props.policies}
            defaultOrderBy={"name"}
            onDialogClose={props.onDialogClose}
            renderRow={(row) => (
                <TableRow key={row.id}>
                    <TableCell>
                        {permissions.policyPermissions.read ? (
                            <DotLegalLink linkColor={"primary"} bold to={getPolicyUrl(row.id)}>
                                {row.name}
                            </DotLegalLink>
                        ) : (
                            row.name
                        )}
                    </TableCell>
                    <TableCell>{translatePolicyTypes(row.type.toString())}</TableCell>
                </TableRow>
            )}
        />
    );
}
